const WORDS = ["Mouvement", "Équilibre", "Respiration", "Écoute", "Ostéopathie douce", "Vitalité", "Présence", "Corps"];

const MarqueeRow = () => (
  <div className="flex shrink-0 items-center">
    {WORDS.map((w) => (
      <span key={w} className="flex items-center">
        <span className="whitespace-nowrap px-8 font-serif text-2xl font-light italic text-taupe/90 md:text-3xl">
          {w}
        </span>
        <span className="inline-block h-1.5 w-1.5 rotate-45 bg-gold/70" />
      </span>
    ))}
  </div>
);

const Marquee = () => (
  <div className="overflow-hidden border-y border-sage-light/50 bg-sage-pale py-7" data-testid="editorial-marquee">
    <div className="marquee-track flex w-max">
      <MarqueeRow />
      <MarqueeRow />
    </div>
  </div>
);

export default Marquee;
